import React from 'react'
import { styleCheckBoxs } from './styleCheckBoxs'
import { useCheckBoxs } from './useCheckBoxs'

const CheckBoxs = ({
    checkBoxPersonal,
    checkBoxBusiness,
    handleCheckBoxClick,
    setCheckBoxBusiness,
    setCheckBoxPersonal,
}) => {
    const { width } = useCheckBoxs()
    return (
        <CheckBoxsWrapperSC>
            <CheckBoxWrapperSC
                onClick={() => handleCheckBoxClick(setCheckBoxPersonal)}
            >
                <CheckBoxInputSC
                    type="checkbox"
                    name="personal"
                    value={checkBoxPersonal}
                />
                {checkBoxPersonal &&
                    (width < 870 ? (
                        <CheckBoxActiveTableSC />
                    ) : (
                        <CheckBoxActiveSC />
                    ))}
                {!checkBoxPersonal && <CheckBoxSC />}
                <CheckBoxTextSC>Для личных задач</CheckBoxTextSC>
            </CheckBoxWrapperSC>
            <CheckBoxWrapperSC
                onClick={() => handleCheckBoxClick(setCheckBoxBusiness)}
            >
                <CheckBoxInputSC
                    type="checkbox"
                    name="business"
                    value={checkBoxBusiness}
                />
                {checkBoxBusiness &&
                    (width < 870 ? (
                        <CheckBoxActiveTableSC />
                    ) : (
                        <CheckBoxActiveSC />
                    ))}
                {!checkBoxBusiness && <CheckBoxSC />}
                <CheckBoxTextSC>Для бизнеса</CheckBoxTextSC>
            </CheckBoxWrapperSC>
        </CheckBoxsWrapperSC>
    )
}

const {
    CheckBoxSC,
    CheckBoxTextSC,
    CheckBoxInputSC,
    CheckBoxActiveSC,
    CheckBoxWrapperSC,
    CheckBoxsWrapperSC,
    CheckBoxActiveTableSC,
} = styleCheckBoxs()

export default React.memo(CheckBoxs)
